import { AiOutlineSketch, AiOutlineQuestionCircle, AiOutlineHome } from 'react-icons/ai'
import { TbMail } from 'react-icons/tb'
import { HiOutlineAcademicCap } from 'react-icons/hi'
import { MdOutlineRocketLaunch } from 'react-icons/md'
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/calendar.svg'
import ContentPaperEdit from '../../../../assets/icons/content-paper-edit'
import { TAppPath } from '../../../../hooks/use-get-app-routes'
import { RiVipFill } from 'react-icons/ri'
import { RxCalendar } from 'react-icons/rx'

export const RoutesIcons: Record<TAppPath, JSX.Element> = {
  '/home': <AiOutlineHome className="icon" style={{ width: 24, height: 24 }} />,
  '/planejamento': <RxCalendar className="icon" style={{ width: 24, height: 24 }} />,
  '/questoes': <ContentPaperEdit className="icon" style={{ width: 24, height: 24 }} />,
  '/course/652d448fc0734d00343ba192': <RiVipFill size={24} />,
  '/premium': <RiVipFill size={24} />,
  '/my-contents': <HiOutlineAcademicCap className="icon" style={{ width: 24, height: 24 }} />,
  '/desempenho': <MdOutlineRocketLaunch className="icon" style={{ width: 24, height: 24 }} />,
  '/subscription': <AiOutlineSketch className="icon" style={{ width: 24, height: 24 }} />,
  '/duvidas': <AiOutlineQuestionCircle className="icon" style={{ width: 24, height: 24 }} />,
  '/recados': <TbMail className="icon" style={{ width: 24, height: 24 }} />,
  '/prazos': <CalendarIcon className="icon" style={{ width: 24, height: 24 }} />,
}
